<template>
  <div class="container">
    <div class="ui grid stackable">
      <div class="twelve wide column">
        <h1>Company Discount Listings</h1>
      </div>

      <listing-buttons :name="btnName" :route="route"></listing-buttons>
    </div>

    <div class="ui divider"></div>

    <div id="table">
      <div class="filter-bar ui grid">
        <div class="ui stackable grid form px-0">
          <div
            class="column"
            v-for="(field, index) in searchFields"
            :key="field.key"
            :class="[{ 'pl-0': index === 0 }, field.class]"
          >
            <div class="ui input" style="width: 100%;">
              <input
                type="text"
                v-model="search.fields[field.key]"
                @keyup.enter="doFilter"
                :placeholder="field.name"
              />
            </div>
          </div>
          <div class="column two wide">
            <div class="ui button" @click="doFilter">Search</div>
          </div>
          <div class="column two wide align-middle">
            <div class="ui checkbox" style="top: 10px;">
              <input
                type="checkbox"
                name="inactive"
                v-model="search.inactive"
              />
              <label>Inactive</label>
            </div>
          </div>
        </div>
      </div>
      <vuetable
        ref="vuetable"
        :api-url="apiUrl"
        :fields="fields"
        :data="discounts"
        pagination-path
        :per-page="10"
        :multi-sort="true"
        :sort-order="sortOrder"
        :append-params="moreParams"
        @vuetable:pagination-data="onPaginationData"
        :http-options="httpOptions"
      >
        <template slot="assembly" slot-scope="props">
          {{
            props.rowData.assembly.parentAssembly
              ? props.rowData.assembly.parentAssembly.name
              : ""
          }}
          - {{ props.rowData.assembly.name }}
        </template>
        <template slot="discount" slot-scope="props">
          {{ props.rowData.discount }}%
        </template>
        <template slot="actions" slot-scope="discount">
          <div class="table-button-container">
            <button class="ui button primary" @click="goToDetail(discount)">
              <i class="fa fa-edit"></i>
            </button>
            <button class="ui button" @click="deleteModal(discount.rowData.id)">
              <i class="fa fa-remove"></i>
            </button>
          </div>
        </template>
      </vuetable>

      <vuetable-pagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>
    <semantic-modal medium flip vertical :active.sync="showModal">
      <i class="close icon"></i>
      <div class="header">Are you sure you want to delete this discount?</div>
      <div class="actions">
        <div class="ui black deny button" @click="showModal = false">Nope</div>
        <div
          class="ui positive right labeled icon button"
          @click="companyDiscountDelete(id)"
        >
          Yes
          <i class="checkmark icon"></i>
        </div>
      </div>
    </semantic-modal>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import APIService from "@/assets/js/APIService";
import httpClient from "@/assets/js/HttpClient";
import SemanticModal from "vue-ya-semantic-modal";

const apiService = new APIService();
export default {
  Name: "ManageCompanyDiscounts",
  computed: {},
  components: {
    SemanticModal: SemanticModal(),
    Vuetable,
    VuetablePagination,
  },
  data() {
    return {
      btnName: "Discount",
      route: "Manage Company Discount Details",
      showModal: false,
      id: "",
      fields: [
        {
          name: "part.code",
          title: "Part Code",
          sortField: "code",
        },
        {
          name: "part.description",
          title: "Item",
        },
        {
          name: "company.code",
          title: "Company #",
          sortField: "company",
        },
        {
          name: "company.name",
          title: "Company Name",
        },
        {
          name: "machine.description",
          title: "Machine Name",
        },
        {
          name: "__slot:assembly",
          title: "Assembly/Sub Assembly",
        },
        {
          name: "__slot:discount",
          title: "Discount",
        },
        "__slot:actions",
      ],
      sortOrder: [
        {
          field: "code",
          sortField: "code",
          direction: "asc",
        },
      ],
      moreParams: {},
      discounts: [],
      apiUrl: apiService.getCompanyDiscountUrl(),
      httpOptions: {
        headers: httpClient.defaults.headers,
      },
      search: {
        filterText: "",
        filters: "",
        fields: {},
        inactive: false,
      },
      searchFields: [
        {
          name: "Part Code",
          key: "partCode",
          class: "two wide",
        },
        {
          name: "Item",
          key: "partDescription",
          class: "two wide",
        },
        {
          name: "Company #",
          key: "companyCode",
          class: "two wide",
        },
        {
          name: "Company Name",
          key: "companyName",
          class: "two wide",
        },
        {
          name: "Machine Name",
          key: "machineName",
          class: "two wide",
        },
        {
          name: "Assembly Name",
          key: "assemblyName",
          class: "two wide",
        },
      ],
    };
  },
  mounted() {
    $(".ui.dropdown").dropdown({ fullTextSearch: true });
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset(e));

    if (this.$route.query.search != null) {
      this.setSearchParams(this.$route.query.search);
    }
  },
  methods: {
    setSearchParams(filterText) {
      if (filterText) {
        const filters = String(filterText).split("|");
        const fields = {};
        filters.forEach((f) => {
          const [key, value] = f.split("-");
          fields[key] = value;
        });

        this.search = Object.assign({}, this.search, { fields });
      }
      this.search.filterText = filterText;
      this.doFilter();
    },
    getDiscounts() {
      apiService.getCompanyDiscounts().then((data) => {
        this.discounts = data;
      });
    },
    deleteModal(id) {
      this.showModal = !this.showModal;
      this.id = id;
    },
    companyDiscountDelete(id) {
      apiService
        .deleteCompanyDiscount(id)
        .then(() => {
          this.showModal = !this.showModal;
          Vue.nextTick(() => this.$refs.vuetable?.refresh());
        })
        .catch((err) => this.companyDiscountFailed(err));
    },
    goToDetail(discount) {
      this.$router.push({
        name: "Manage Company Discount Details",
        params: {
          id: discount.rowData.id,
        },
      });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    doFilter() {
      const filterText = Object.keys(this.search.fields)
        .map((k) =>
          this.search.fields[k] ? `${k}-${this.search.fields[k]}` : ""
        )
        .join("|");
      if (this.search.filterText !== filterText) {
        this.search = Object.assign({}, this.search, { filterText });
      }
      this.$events.fire("filter-set", this.search);

      if (this.$route.query.search !== null) {
        this.$set(
          this.search,
          this.search.filterText,
          this.$route.query.search
        );
      } else {
        this.$router.push({
          path: "discounts",
          query: { search: this.search.filterText },
        });
      }

      if (this.$route.query.search != this.search.filterText) {
        delete this.$route.query.search;
        this.$router.push({
          path: "discounts",
          query: { search: this.search.filterText },
        });
      }
    },
    onFilterSet(data) {
      this.moreParams.filter = data.filterText;
      this.moreParams.inactive = data.inactive || this.active;
      Vue.nextTick(() => {
        this.$refs.vuetable?.refresh();
      });
    },
    onFilterReset() {
      delete this.moreParams.filter;
      Vue.nextTick(() => this.$refs.vuetable?.refresh());
    },
    companyDiscountFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
  },
  destroyed: function() {
    this.$events.$off("filter-set");
    this.$events.$off("filter-reset");
  },
};
</script>
